import { createRouter, createWebHistory } from 'vue-router'
import { constantRoutes } from "@/router/constans";
import { isMobileDevice } from '@/utils/common.js';
import useAppStore from '@/store/modules/app.js';
import { Modal } from 'ant-design-vue';
import { createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
});
// 全局路由
router.beforeEach((to, from, next) => {
  // 判断是否移动端并写入Pinia
  const appStore = useAppStore();
  const isMobile = isMobileDevice()
  appStore.setIsMobile(isMobile);

  // 离开确认白名单:所有试题组件调用的路由
  const confirmExitPaths = [
    '/general',
    '/separate-enrollment',
    '/collage-entrance',

  ];

  // 当来源路由在确认白名单时触发弹窗
  // if (confirmExitPaths.includes(from.path)) {
  //   const answer = Modal.confirm({
  //     title: '离开确认',
  //     icon: createVNode(ExclamationCircleOutlined),
  //     content: '是否要离开当前页面并结束当前练习？',
  //     onOk:()=>{
  //
  //     },
  //     onCancel:()=>{
  //       return next(false); // 取消导航
  //     }
  //   });
  // }

  let whiteList = [
      '/',
      '/login',
    '/home', //首页
    '/student-status', // 学生信息
    '/student-evaluate',  // 学生评价
    '/student-mental-health', // 学生心理健康
    '/teacher-status', //教师信息
    // '/teacher-honor', //教师荣誉
    '/teacher-evaluate', // 教师评价
    '/general', // 普测练习
    '/separate-enrollment', // 单招练习
    '/collage-entrance', // 高考练习
    '/exam-online', // 在线考试
    '/homework', // 班级作业
  ];

  if (isMobile && !whiteList.includes(to.path) && to.path !== '/mobile-warning') {
    console.log('to router:', to);
    appStore.setMobileRoute(to);
    next({ path: '/mobile-warning' })
  } else {
    next();
  }


});


export default router;